import { createFileRoute } from "@tanstack/react-router";
import { AgentConversationRoute } from "@/components/agents/agent-conversation-route";

export const Route = createFileRoute(
	"/$owner/agents/$agentId/conversations/$conversationId",
)({
	component: AgentConversationPage,
});

function AgentConversationPage() {
	const { owner, agentId, conversationId } = Route.useParams();
	return (
		<AgentConversationRoute
			owner={owner}
			agentId={agentId}
			conversationId={conversationId}
		/>
	);
}
